/**
 * Return the occupied circular-buffer indices in queue order.
 *
 * A full circular buffer has the same start and end index, so callers must
 * iterate by the tracked size rather than treating start === end as empty.
 */
export const getCircularQueueIndices = (
  start: number | undefined,
  size: number,
  capacity: number,
): number[] => {
  if (start === undefined || size <= 0 || capacity <= 0) {
    return [];
  }

  return Array.from({ length: size }, (_, offset) => (start + offset) % capacity);
};
